import * as React from 'react';
import type { SVGProps } from 'react';

const SvgData = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 32 32" {...props}>
    <path d="M16.03 2.32c-6.71 0-13.84 2.1-13.84 5.99v16.12c0 3.89 7.13 5.99 13.84 5.99s13.84-2.1 13.84-5.99V8.31c0-3.89-7.13-5.99-13.84-5.99Zm0 2.21c7.1 0 11.62 2.24 11.62 3.78 0 1.54-4.53 3.78-11.62 3.78-7.09 0-11.62-2.24-11.62-3.78 0-1.54 4.53-3.78 11.62-3.78Zm0 23.68c-7.1 0-11.62-2.24-11.62-3.78V11.66c2.63 1.73 7.21 2.65 11.62 2.65 4.41 0 8.99-.91 11.62-2.65v12.77c0 1.54-4.53 3.78-11.62 3.78Z" />
  </svg>
);

export default SvgData;
